/**
 * This is a class for representing dynamic asset comment.
 */
import * as THREE from 'three';
import { Vector3 } from 'three';

import { AssetLoadingStatus, AssetType, ElementObj } from './element-obj';
import { Poi } from './poi/poi';

export type ClusterProperties = {
  displayPoi?: Poi;
  size: number;
};

export class Cluster extends ElementObj {
  get properties() {
    return this._properties;
  }

  onMetaDataUpdated?: () => void;

  constructor(private _properties: ClusterProperties) {
    super(null);
  }

  initialLoadingStatus(): AssetLoadingStatus {
    return 'loaded';
  }

  get assetType(): AssetType {
    return 'poi';
  }

  private _members: Poi[] = [];
  get members(): Poi[] {
    return this._members;
  }
  set members(pois: Poi[]) {
    const sumPosition = pois.reduce((sumPosition, poi) => {
      return sumPosition.add(poi.position);
    }, new Vector3());

    this.position.copy(sumPosition.divideScalar(pois.length));
    this._members = pois;
  }

  dispose() {
    function disposeNode(node: THREE.Object3D) {
      for (const child of node.children) {
        disposeNode(child);
        const childAsMesh = child as THREE.Mesh;
        if (childAsMesh.geometry) {
          childAsMesh.geometry.dispose();
        }
        if (childAsMesh.material) {
          const materalArray = Array.isArray(childAsMesh.material)
            ? childAsMesh.material
            : [childAsMesh.material];
          for (const material of materalArray) {
            material.dispose();
          }
        }
      }
    }
    disposeNode(this);
  }

  getClusterSize() {
    return this._properties.size;
  }

  getThumbnailResourceUrl() {
    return this._properties?.displayPoi?.getThumbnailResourceUrl('64x_');
  }
}
